import React from 'react';
import { ShieldIcon, CircleCheckIcon, LockIcon, DownloadIcon, CalendarIcon } from './Icons';
export const Guarantee = () => {
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-77">
      <div className="max-w-[700px] mx-auto flex flex-col items-center" data-id="element-78">
        <ShieldIcon color="#957DAD" size={64} className="mb-5" data-id="element-79" />

        <h2 className="font-playfair text-[26px] md:text-[36px] text-primary text-center mb-5" data-id="element-80">
          A Quiet 30-Day Guarantee
        </h2>

        <p className="font-lato text-[16px] md:text-[17px] text-secondary text-center leading-[1.8] mb-8" data-id="element-81">
          Take 30 days to explore the method gently, at your own pace. If it
          doesn't feel like the right fit for your body and your life, simply
          let us know — we'll refund you in full. No forms. No friction. No
          pressure to explain.
        </p>

        <div className="w-full border-[2px] border-medium rounded-[20px] p-6 md:p-10 bg-gradient-to-br from-white to-light shadow-[0_8px_32px_rgba(149,125,173,0.15)] flex flex-col items-center" data-id="element-82">
          <div className="flex flex-col md:flex-row gap-3 md:gap-4 w-full justify-center" data-id="element-83">
            <div className="bg-light text-medium font-lato font-bold text-[13px] py-[10px] px-[18px] rounded-[50px] border border-accent inline-flex items-center justify-center gap-2" data-id="element-84">
              <CircleCheckIcon color="#957DAD" size={16} data-id="element-85" />
              <LockIcon color="#957DAD" size={16} data-id="element-86" />
              <span data-id="element-87">Secure SSL Payment</span>
            </div>
            <div className="bg-light text-medium font-lato font-bold text-[13px] py-[10px] px-[18px] rounded-[50px] border border-accent inline-flex items-center justify-center gap-2" data-id="element-88">
              <CircleCheckIcon color="#957DAD" size={16} data-id="element-89" />
              <DownloadIcon color="#957DAD" size={16} data-id="element-90" />
              <span data-id="element-91">Instant Access</span>
            </div>
            <div className="bg-light text-medium font-lato font-bold text-[13px] py-[10px] px-[18px] rounded-[50px] border border-accent inline-flex items-center justify-center gap-2" data-id="element-92">
              <CircleCheckIcon color="#957DAD" size={16} data-id="element-93" />
              <CalendarIcon color="#957DAD" size={16} data-id="element-94" />
              <span data-id="element-95">No Subscription</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};